var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import FullToolbar from './FullToolbar';
import MobileToolbar from './MobileToolbar';
var MainToolbar = /** @class */ (function (_super) {
    __extends(MainToolbar, _super);
    function MainToolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MainToolbar.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(FullToolbar, { history: this.props.history, routes: this.props.routes, isDevStage: this.props.isDevStage }),
            React.createElement(MobileToolbar, { routes: this.props.routes })));
    };
    return MainToolbar;
}(React.PureComponent));
export default MainToolbar;



//////////////////
// WEBPACK FOOTER
// ./src/components/layouts/Main/MainToolbar.tsx
// module id = 2024
// module chunks = 81